function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_310",
  "data-name": "Group 310",
  transform: "translate(-99.631 -397.97)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_176",
  "data-name": "Group 176",
  transform: "translate(100.148 398.47)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 5.147,
  cy: 4.973,
  rx: 5.147,
  ry: 4.973,
  transform: "translate(2.852)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_242",
  "data-name": "Path 242",
  d: "M413.269,265.178c-.972-1.863-2.985-3.628-7.118-3.628-8.764,0-7.992,7.928-7.992,7.928",
  transform: "translate(-398.141 -249.478)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_243",
  "data-name": "Path 243",
  d: "M412.023,268.853a8.69,8.69,0,0,0-.194-2.42",
  transform: "translate(-396.04 -248.853)",
  fill: "none",
  stroke: "#2c3589",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoPerson = function SvgJoratoPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.026,
    height: 21.046,
    viewBox: "0 0 17.026 21.046",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-person.40900e72.svg";
export { ForwardRef as ReactComponent };